// petFee — what typing in (or clearing) the pet-fee box means.
//
// OWNER RULING 2026-09-07: "we need pets cost extra box — if it's left empty then there is none,
// if filled it means costs." It replaced a tri-state pill that said the same sentence in all
// three states and drew "✓ a pet costs extra" for the state that meant the opposite. An amount
// cannot contradict itself: a number IS the fee, and nothing IS no fee.
//
// ⚠️ "EMPTY MEANS NONE" IS ABOUT THE BOX IN FRONT OF THE AGENT, NOT ABOUT THE CORPUS.
// 7,076 of 7,101 terms rows have never been asked about pets (measured 2026-09-07). A rule that
// turned every untouched empty box into "free" would assert a fact about seven thousand flats
// nobody phoned — and would look completely correct on screen while doing it, which is why this
// lives in its own tested module instead of inside an onChange handler.
//
// ⚠️ Its own module, not a helper inside the modal, for one boring reason as well: `node --test`
// cannot import a .jsx file, so a rule that lives in a component is a rule with no test.
export function nextPetFee(prev, v) {
  const had = prev?.pet_deposit_extra !== '' && prev?.pet_deposit_extra != null
  return {
    pet_deposit_extra: v,
    //   type a number -> there IS a fee
    //   clear a value -> a deliberate act, so: none
    //   leave empty   -> unchanged; for most listings that means "still nobody asked"
    pet_deposit_required: v !== '' ? 'true' : had ? 'false' : prev?.pet_deposit_required,
  }
}

// ── DOES THE RECORDED PETS ANSWER PERMIT A PET? ───────────────────────────────────────────────
// The gate the fee box hangs on (owner ruling 2026-09-07: "are pets allowed by a deposit or not
// at all?"). Only a PERMISSION can carry a price: under a refusal — negotiable or not — there is
// nothing to charge for, and a refusal with an amount beside it is the contradiction the move
// exists to end (7 of 23 fee rows were in exactly that state).
//
// ⚠️ An UNANSWERED question shows no box either. A price field on a question nobody has answered
// invites recording a fee for a flat that may well refuse pets — which is how those 7 rows were
// created in the first place.
//
// ⚠️ Pure and exported because the panel it lives in cannot be rendered by a static harness: its
// rules arrive from a fetch, so a render test of the component returns an empty shell and every
// assertion over it passes while proving nothing. Measured 2026-09-07 — the first version of that
// harness reported "no box" for all four answers, including the one that must show it.
export function petsPermit(rules, predicateKeyOf, petsKey) {
  const answer = (rules || []).find(r => predicateKeyOf(r) === petsKey)
  return answer?.polarity === 'allow' || answer?.polarity === 'prefer'
}
